import React from "react"
import { isIE } from "react-device-detect"
import loadable from "@react-loadable/revised"

export default function MotionIcon({ children, icon }) {
  const LoadableIcon = loadable({
    loader() {
      return import("../components/svg/motion-icon-" + icon)
    },
    loading: () => {
      return children
    },
  })

  return isIE ? children : <LoadableIcon />
}
